import { fetchContacts, insertContact, patchClient, updateContact } from '../services/clients';
import { notify } from '../store/feedback';

/* Traitements « clients », sortis de App.js. `deps` porte l'état et les setters du composant ;
   `api` donne accès aux traitements des autres domaines (rempli dans App.js, lu au moment de
   l'appel, donc l'ordre de création n'importe pas). */
export default function clientsHandlers(deps, api) {
  const { contactModal, setContactModal, setContacts, setContactsLoaded, setCrmClients } = deps;

  async function loadContacts() {
    const { data } = await fetchContacts();
    setContacts(data || []);
    setContactsLoaded(true);
  }

  function openClient(c) {
    setContactModal(
      c
        ? {
            ...c,
            // Coordonnées : on récupère les champs société si les champs contact sont vides
            contact_tel: c.contact_tel || c.telephone || '',
            contact_email: c.contact_email || c.email || '',
          }
        : {
            nom: '',
            statut: 'prospect',
            origine: '',
            secteurs: [],
            contact_prenom: '',
            contact_nom: '',
            contact_tel: '',
            contact_email: '',
            email: '',
            telephone: '',
            adresse: '',
            notes: '',
          },
    );
  }

  async function saveContactPatch(id, patch) {
    await patchClient(id, patch);
    setContacts((list) => list.map((c) => (c.id === id ? { ...c, ...patch } : c)));
    setCrmClients((list) => list.map((c) => (c.id === id ? { ...c, ...patch } : c)));
  }

  async function saveContactModal() {
    const c = contactModal;
    if (!c.nom || !c.nom.trim()) {
      notify('Le nom est requis.');
      return;
    }
    const row = {
      nom: c.nom.trim(),
      statut: c.statut || 'prospect',
      origine: c.origine || null,
      secteurs: c.secteurs || [],
      contact_prenom: c.contact_prenom || null,
      contact_nom: c.contact_nom || null,
      contact_tel: c.contact_tel || null,
      contact_email: c.contact_email || null,
      email: c.email || null,
      telephone: c.telephone || null,
      adresse: c.adresse || null,
      notes: c.notes || null,
    };
    if (c.id) {
      await updateContact(c, row);
    } else {
      await insertContact(row);
    }
    setContactModal(null);
    loadContacts();
    api.loadDeals(); // rafraîchit les noms/secteurs côté affaires
  }

  return {
    loadContacts,
    openClient,
    saveContactModal,
    saveContactPatch,
  };
}
